import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

function TitlePlanosSobral() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <MKBox component="section" my={0} py={0}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKBadge
            variant="contained"
            color="info"
            badgeContent="PLANOS SOBRALNET"
            container
            sx={{ mb: 2 }}
          />
          <MKTypography variant="h2" fontWeight="bold">
            Planos
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            Os planos SCM referem-se aos Serviços de Comunicação Multimídia
          </MKTypography>

          {/* Aviso adaptável por tipo de tela */}
          <MKBox
            sx={{
              background: "#e3f2fd",
              borderRadius: "16px",
              p: 2,
              boxShadow: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
              animation: "pulse 2s infinite",
              "@keyframes pulse": {
                "0%": { transform: "scale(1)" },
                "50%": { transform: "scale(1.02)" },
                "100%": { transform: "scale(1)" },
              },
            }}
          >
            {isMobile ? (
              <MKTypography variant="body1" color="info" fontWeight="medium">
                📱 Toque no plano para ver os benefícios
              </MKTypography>
            ) : (
              <MKTypography variant="body1" color="info" fontWeight="medium">
                💻 Passe o cursor sobre o plano para ver os benefícios
              </MKTypography>
            )}
            <ArrowDownwardIcon sx={{ fontSize: 40, color: "#1976d2", mt: 1 }} />
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default TitlePlanosSobral;
